import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useToasts } from "react-toast-notifications";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import "./style.scss";

const PForgotPasswordForm = ({ show, setShow }) => {
    const { addToast } = useToasts();
    const { executeRecaptcha } = useGoogleReCaptcha();

    const [isLoading, setIsLoading] = useState(false);

    const onSubmitWithReCAPTCHA = async (e) => {
        e.preventDefault();
        if (!executeRecaptcha) {
            console.log("Execute recaptcha not yet available in login");
        } else {
            const token = await executeRecaptcha("forgot_password");
            formik.setFieldValue("isHuman", token, false);
            formik.handleSubmit();
        }
    };

    const formik = useFormik({
        initialValues: {
            login: "",
        },
        validationSchema: Yup.object({
            login: Yup.string().required("Account login is required"),
        }),
        onSubmit: async (values, { setErrors }) => {
            setIsLoading(true);
            await axios
                .post("/api/forgot-password", { ...values })
                .then((response) => {
                    console.log({ response });
                    addToast(
                        "If the email exists, a reset link has been sent to the email.",
                        { appearance: "success", autoDismiss: true }
                    );
                    setIsLoading(false);
                    setShow(false);
                    formik.setFieldValue("login", "", false);
                })
                .catch((error) => {
                    console.log({ error });
                    setIsLoading(false);
                    if (error.response && error.response.status == 422) {
                        const responseData = error.response.data;
                        const firstErrorKey = Object.keys(responseData.errors);

                        formik.setFieldError(
                            "login",
                            responseData.errors[firstErrorKey[0]]
                        );
                    }
                    addToast("Unable to send password reset link", {
                        appearance: "error",
                        autoDismiss: true,
                    });
                });
        },
    });

    const handleClose = () => {
        setShow(false);
        formik.setFieldValue("login", "");
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="md"
            centered
            className="forgot-password-modal"
        >
            <div className="forgot-password px-3 py-4">
                <form onSubmit={onSubmitWithReCAPTCHA}>
                    <label htmlFor="login-account">
                        Enter the email address assigned to your account.
                    </label>
                    <div className="input-group has-validation">
                        <div className="input-group-prepend">
                            <span
                                className="input-group-text"
                                id="loginAccount"
                            >
                                <i className="fa-solid fa-user"></i>
                            </span>
                        </div>
                        <input
                            type="email"
                            id="forgot-password"
                            name="login"
                            className={`form-control${
                                formik.errors.login && formik.touched.login
                                    ? " is-invalid"
                                    : ""
                            }`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.login}
                        />
                    </div>

                    {formik.errors.login && formik.touched.login ? (
                        <div className="invalid-feedback">
                            {formik.errors.login}
                        </div>
                    ) : null}

                    <div className="float-right mt-4">
                        <Button
                            type="button"
                            variant="light"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={isLoading}
                        >
                            {isLoading ? "Processing" : "Submit"}
                        </Button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default PForgotPasswordForm;
